import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function CoreValuesEnPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/netbasis-core-values-trust-partnership.webp"
      texts={{
        title: "Core Values",
        heroClaimLine1: "With values",
        heroClaimLine2: "to success!",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Our Core Values | NetBasis International"
      metaDescription="Respect, loyalty, professionalism, perseverance, and trust – the fundamental pillars for the sustainable success of our manufacturer partners."
      metaOgUrl="https://net-basis.net/en/about-us/core-values"
    >
      <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
        <h1 className="font-semibold text-foreground-950 text-sm md:text-base">
          Respect. Loyalty. Professionalism. Perseverance. Trust.
        </h1>
        <p>These are the foundational core values to which NetBasis International is firmly committed and that guide us through our daily work. They accompany us in our unwavering dedication to our business partners and govern the precise manner in which we fulfill our operational responsibilities.</p>
        <p>It is our daily commitment to ourselves to consistently prove to new partners that they have made the absolute right choice with us, and to show our existing partners in joint projects time and again that they are in the best hands and thoroughly well taken care of.</p>
        <p>Your success is our obligation.</p>
      </div>
    </AboutSubPage>
  );
}